/**
 * created by lei lei on 2020/6/12
 * 文章数，标题下对应数字
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Col, Row} from "antd";

export default class NumberArticles extends Component {
    static defaultProps = {
        color:'black'
    };
    static propTypes = {
        title:PropTypes.string.isRequired,//标题
        num:PropTypes.number.isRequired,//数量键值必传项
        onClickFunction:PropTypes.func,//点击当前小模块,非必传项
        showLin:PropTypes.bool,//是否显示右边边线
        color:PropTypes.string//是否显示右边边线

    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className={'NumberArticles'} style={{background:'white', borderRadius: "5px",display:'grid', columnGap:'20px',
                justifyContent: 'space-between',
                gridTemplateColumns:' repeat(auto-fill, 180px)',}}>
                                    <div onClick={() => {
                                        this.props.onClickFunction&&this.props.onClickFunction()
                                    }} style={{cursor:'default',height:130,position:'relative',width:'100%'}}>

                                        <div style={{paddingTop:30,fontSize:14}}>
                                            <div style={{textAlign:'center',}}>
                                                {this.props.title}
                                            </div>
                                        </div>
                                        <div style={{textAlign:'center',fontSize:16,marginTop:15,color:this.props.color}}>{this.props.num}</div>

                                    </div>

            </div>
        )
    }

}